import { PhotoSpinner } from './PhotoSpinner';

/** Covers the frame while a chosen photo is being read by the browser. */
export function PhotoReadingOverlay() {
  return (
    <div
      style={{
        position: 'absolute',
        inset: 0,
        background: 'rgba(15,25,18,.58)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 10,
        color: '#fff',
      }}
    >
      <PhotoSpinner />
      <div style={{ fontSize: 12.5, fontWeight: 700 }}>Reading photo…</div>
    </div>
  );
}
